import { render } from "./UsersList.vue?vue&type=template&id=4148002a"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=4148002a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__